var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.133 4.23804L8.7753 17.5957L3.8672 12.6876C3.62924 12.4497 3.2434 12.4497 3.0054 12.6876L1.5691 14.1239C1.33113 14.3619 1.33113 14.7477 1.5691 14.9857L8.34439 21.7611C8.58234 21.999 8.96818 21.999 9.20619 21.7611L24.431 6.53615C24.6691 6.29819 24.6691 5.91236 24.431 5.67435L22.9947 4.23804C22.7568 4.00008 22.371 4.00008 22.133 4.23804Z",
    fill: "#74767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheck);
export default __webpack_public_path__ + "static/media/grayCheck.ec50975eb4a79bd13569650cf4dc5070.svg";
export { ForwardRef as ReactComponent };